const notEmpty = (value) => value !== undefined
  && value !== null
  && value !== '';

export { notEmpty };
